/**
 * @generated SignedSource<<b0d1445a0e0cf966ffffe00b8167b574>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_item$data = {
  readonly localizedPdpUrl: string | null;
  readonly measurement: {
    readonly " $fragmentSpreads": FragmentRefs<"useProductDimensions_measurement">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_item" | "ProductPrice_item" | "ProductShipping_item" | "ProductTitle_item" | "QuickView_item" | "SwatchSelectorMinimal_item">;
  readonly " $fragmentType": "ProductBaseTile_item";
};
export type ProductBaseTile_item$key = {
  readonly " $data"?: ProductBaseTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "kind": "LinkedField",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useProductDimensions_measurement"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductTitle_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SwatchSelectorMinimal_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickView_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a7ca8eba117f68c85d08900e0c8c575f";

export default node;
